import {useRef} from 'react'
import {clsx} from 'clsx'

import {ChevronRightIcon} from '@primer/octicons-react'

import {NavGroup, type NavGroupType} from '../NavGroup/NavGroup'
import {NavLink} from '../NavLink/NavLink'
import type {NavLinkType} from '../NavLink/NavLink'

import {useDropdownPositioning} from './use-dropdown-positioning'

import styles from './NavDropdown.module.css'

export type NavDropdownType = {
  groups: NavGroupType[]
  render?: boolean
  title: string
  trailingLink?: NavLinkType
}

export function NavDropdown(props: NavDropdownType) {
  const {title, groups, render = true, trailingLink} = props

  const containerRef = useRef<HTMLDivElement>(null)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useDropdownPositioning(containerRef, dropdownRef)

  if (render === false) {
    return null
  }

  // TODO: Replace global js behavior with React state management or popover API
  return (
    <div ref={containerRef} className={clsx(styles.container, 'js-details-container js-header-menu-item')}>
      <button type="button" className={clsx(styles.button, 'js-details-target')} aria-expanded="false">
        {title}

        <ChevronRightIcon className={clsx(styles.buttonIcon)} />
      </button>

      <div ref={dropdownRef} className={clsx(styles.dropdown)}>
        <ul className={styles.list}>
          {groups.map(group => (
            <li key={group.title}>
              <NavGroup {...group} context={title} />
            </li>
          ))}
        </ul>

        {trailingLink ? (
          <div className={styles.trailingLinkContainer}>
            <NavLink {...trailingLink} context={title} withArrow />
          </div>
        ) : null}
      </div>
    </div>
  )
}
